import { Outlet } from 'react-router-dom';

import { Trans } from 'react-i18next';

import udi_img2 from '@/assets/images/UniqueDeviceIdentifier.png';

import { LanguageSwitcher } from '@/components/language-switcher';

import { Copyright } from '../footer/copyright';
import { Logo } from '../logo';

export function LayoutAuth() {
  return (
    <main className="isolate relative">
      <LanguageSwitcher />
      <div className="flex lg:min-h-screen w-full box-border flex-col lg:flex-row">
        <div className="hidden lg:flex basis-1/2 flex-col items-center justify-center rounded-r-xl bg-gradient-to-br from-secondary from-50% via-sky-200 dark:via-sky-900 via-90% to-sky-200 dark:to-sky-900 text-white">
          <div className="flex-1 flex flex-col items-center lg:justify-center">
            <Trans i18nKey="splash-welcome">
              <h1 className="inline-flex lg:flex-col gap-1 items-center text-2xl lg:text-8xl font-extrabold">
                <span className="lg:text-lg font-normal">Welcome to</span> Vitazi.ai
              </h1>
            </Trans>
            <Trans i18nKey="splash-description">
              <p className="text-xl mt-2">Vitazi.ai Telehealth Portal</p>
            </Trans>
          </div>
          <div className="text-center">
            <p>Vitazi.ai Inc.</p>
            <p>3900 Paseo del Sol,</p>
            <p>Santa Fe, NM 87507</p>
            <a
              className="!text-white"
              href="https://www.vitazi.ai/"
              target="_blank"
              rel="noreferrer"
            >
              Vitazi.ai
            </a>
            <div className="flex-full-center gap-2 text-xs mt-8  px-4 py-2 rounded">
              <span>Rx Only</span>
              <img
                className="w-10 h-10 invert object-scale-down"
                src={udi_img2}
                alt="Unique Device Identifier Logo"
                width={42}
              />
              <span>00860012221608</span>
            </div>
          </div>
        </div>
        <div className="flex basis-1/2 flex-col justify-center items-center my-16 lg:my-20 px-8 box-border overflow-auto">
          <div className="w-full max-w-md">
            <Logo className="w-52 lg:w-72" />
            <Outlet />
          </div>
          <div className="text-center lg:hidden w-full mb-10">
            <hr className="mb-10" />
            <p>Vitazi.ai Inc.</p>
            <p>3900 Paseo del Sol,</p>
            <p>Santa Fe, NM 87507</p>
            <a href="https://www.vitazi.ai/" target="_blank" rel="noreferrer">
              Vitazi.ai
            </a>
            <div className="flex-full-center gap-2 text-xs px-4 py-2 rounded">
              <span>Rx Only</span>
              <img
                className="w-10 h-10 object-scale-down"
                src={udi_img2}
                alt="Unique Device Identifier Logo"
                width={42}
              />
              <span>00860012221608</span>
            </div>
          </div>
          <Copyright />
        </div>
      </div>
    </main>
  );
}
